import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { bottomBarState } from "../states/common";
import TIcon from "./ui/TIcon";

/**
 * Thanh điều hướng dưới — bố cục theo bản demo, thêm nút quét QR nổi ở
 * giữa (giữ lại thao tác nhanh của bản giao diện trước).
 *
 * Bốn tab hai bên + nút QR ở giữa. Mục "Live" không còn ô riêng nhưng vẫn
 * vào được từ dải LIVE và nút XEM LIVE ở trang chủ; khi đang ở /live thì
 * tab "Trang chủ" không sáng, thay vào đó tiêu đề trang tự nói vị trí.
 */
const LEFT_TABS = [
  { key: "home", label: "Trang chủ", icon: "home", path: "/" },
  { key: "league", label: "Giải đấu", icon: "trophy", path: "/league" },
];

const RIGHT_TABS = [
  { key: "ranking", label: "BXH", icon: "list-numbers", path: "/bxh" },
  { key: "profile", label: "Tôi", icon: "user", path: "/profile" },
];

const BottomBar = () => {
  const [active] = useRecoilState(bottomBarState);
  const navigate = useNavigate();

  const renderTab = (t: (typeof LEFT_TABS)[number]) => (
    <button
      key={t.key}
      type="button"
      onClick={() => navigate(t.path)}
      className={`tab${active === t.key ? " active" : ""}`}
    >
      <TIcon name={t.icon} />
      <span>{t.label}</span>
    </button>
  );

  return (
    <nav className="tabbar">
      {LEFT_TABS.map(renderTab)}

      {/* Ô giữ chỗ để 4 tab chia đều, nút QR nổi lên trên nó */}
      <div className="tab-slot" />

      {RIGHT_TABS.map(renderTab)}

      <button
        type="button"
        className="qr-fab"
        aria-label="Quét mã QR"
        /* Vào thẳng "QR của tôi": ai bấm mã QR cũng để cho người khác quét
           mình trước, còn quét người khác là bước sau, có nút riêng ở đó. */
        onClick={() => navigate("/my-qr")}
      >
        <TIcon name="qrcode" />
      </button>
      <span className={`qr-fab-label${active === "qr" ? " active" : ""}`}>
        Quét QR
      </span>
    </nav>
  );
};

export default BottomBar;
